/**
 * @desc 校验当前手机号是否已注册
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CheckPhoneExistsParameter = {
  phone?: string
}

const method = 'POST'
const url = '/auth/register/checkPhone'

export const checkPhoneExistsApi = (
  params?: CheckPhoneExistsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<boolean>({
    method,
    url,
    params,
    ...config
  })
}

checkPhoneExistsApi.method = method
checkPhoneExistsApi.url = url
